<template>
<div class="main-header-page media-print" tabindex="-6">
	<nav class="bread" tabindex="-5" aria-label="Ruta de navegación">
		<span v-if="breadHasMore" class="bread-more" aria-hidden="true">…</span>
		<router-link
			tag="span"
			class="header-page-title"
			v-for="(route, routeIndex) in breadCrumbsToShow"
			:key="routeIndex"
			tabindex="-1"
			:to="{ name: route.name, params: route.params, query: route.query }"
		>
			<span class="header-page-title-text">{{ titleBreadCrumb(route) }}</span>
		</router-link>
	</nav>
	<div class="header-page-actions" tabindex="-1" v-if="toShow && width > 768">
		<v-btn
			v-if="exportToPdf"
			tabindex="-1"
			@click.prevent="downloadDispatch"
			class="header-page-download-document primary mr-2">
			<img :src="`${$imageUrl}/icon-export-pdf.svg`" alt="" class="align-img">
		</v-btn>
		<v-btn
			v-if="showExcel"
			tabindex="-1"
			class="header-page-download-document primary"
			@click="downloadDocument">
			<img :src="`${$imageUrl}/fill-1.svg`" alt="download" height="17">
		</v-btn>
		<v-btn
			dark
			color="pink"
			tabindex="-1"
			class="btn-action"
			v-if="showClean"
			@click="$emit('on-clean')"
		>
			Limpiar
		</v-btn>
		<slot></slot>
	</div>
	<div class="header-page-actions translate"
		v-if="quotation || sale">
		<v-btn
			flat
			class="header-page-download-document"
			tabindex="-1"
			@click="downloadDocument">
			<img :src="`${$imageUrl}/download.svg`" alt="download" height="17">
		</v-btn>
		<v-btn
			flat
			class="header-page-download-document"
			tabindex="-1"
			@click="print">
			<img :src="`${$imageUrl}/print.svg`" alt="download" height="17">
		</v-btn>
	</div>
	<div v-if="actions" class="action-bar-header" tabindex="-1">
		<v-menu content-class="menu-header-page" tabindex="-1">
			<v-btn class="btn-activator" icon slot="activator" tabindex="-1">
				<v-icon color="indigo darken-1">more_vert</v-icon>
			</v-btn>
			<v-card>
				<action-bar
					:value-disabled="valueDisabled"
					:resource-uri="$route.name"
					tabindex="-1"
					@run-action="openAction"
				/>
			</v-card>
		</v-menu>
	</div>
	<div class="content-space-between" tabindex="-1">
		<div tabindex="-1" class="header-detail-journal-mobile" v-if="detailJournalOpen">
			# {{ codeJournal }} - {{ dateJournal }}
		</div>
		<div v-if="searchHeader" class="header-page-search" tabindex="-1">
			<div class="align-center" tabindex="-1">
				<transition name="slide-fade" tabindex="-1">
					<div v-if="show" class="search-input" tabindex="-1">
						<input
							placeholder="Buscar..."
							@keyup.enter="searchRows"
							@keyup.esc="searchRows"
							v-model="search"
							type="text"
							tabindex="-1"
						/>
						<v-icon class="icon-search-input">search</v-icon>
					</div>
				</transition>
				<div class="border-r" tabindex="-1">
					<v-btn class="btn-search" @click="open" tabindex="-1">
						<img class="" src="/static/img/icons/search.svg" width="17" height="17" alt="">
					</v-btn>
				</div>
			</div>
		</div>
		<div v-if="buttonDelete" class="border-r" tabindex="-1">
			<v-btn class="btn-delete" @click="$emit('delete-journal')" tabindex="-1">
				<img src="/static/img/icons/backspace.svg" width="17" height="17px">
			</v-btn>
		</div>
		<div v-if="buttonFilter" tabindex="-1">
			<v-btn class="btn-filter" @click="$emit('click-filter')" tabindex="-1">
				<img src="/static/img/icons/filter.svg" width="17" height="17px">
			</v-btn>
		</div>
		<div v-if="buttonClose" tabindex="-1">
			<v-btn class="btn-close" @click="$emit('click-close')" tabindex="-1">
				<img src="/static/img/sidebar/close.svg" width="17" height="17px">
			</v-btn>
		</div>
	</div>
</div>
</template>

<script>
import actionBar from '@/components/shared/action-bar/action-bar';
import helper from '@/shared/helper';
import { mapGetters } from 'vuex';

const LOCAL_SEARCH_EVENT = 'on-local-search';
const SEARCH_EVENT = 'on-search-event';

function open() {
	this.show = !this.show;
}

function searchRows($event) {
	const keyCode = $event.keyCode;
	if (keyCode === 27) {
		this.search = '';
	}
	if (this.localSearch) {
		const dataToLocalSearch = this.search.toLowerCase();
		helper.setLocalData(`${this.$attrs.name}::search`, dataToLocalSearch);
		this.$emit(LOCAL_SEARCH_EVENT, dataToLocalSearch);
	} else {
		helper.setLocalData(`${this.$attrs.name}::search`, this.search);
		this.$emit(SEARCH_EVENT, this.search);
	}
}

function mounted() {
	this.setWitdh();
	window.addEventListener('resize', this.setWitdh);
}

function columnsToExport() {
	const columnsSelected = this.columns.filter(column => column.visible
		&& !column.flagVisible);
	const newColumns = columnsSelected.map((col) => {
		const newCol = Object.assign({}, col);
		delete newCol.id;
		delete newCol.visible;
		delete newCol.checked;
		return newCol;
	});
	return newColumns;
}

function dataToExport() {
	let tableDataToExport = [];
	const columnsSelected = this.columns.filter(column => column.visible
		&& !column.flagVisible);
	const columnsValues = columnsSelected.map((colVal) => {
		const newColVal = Object.assign({}, colVal);
		return newColVal.value;
	});
	if (this.rows.length > 0) {
		tableDataToExport = this.rows.map((dataExport) => {
			const newData = Object.assign({}, dataExport);
			const keysData = Object.keys(dataExport);
			keysData.forEach((keyData) => {
				if (columnsValues.every(keyCol => keyCol !== keyData)) {
					delete newData[keyData];
				}
			});
			return newData;
		});
	}
	return tableDataToExport;
}

function downloadDispatch() {
	this.$emit('download-dispatch');
}

function downloadDocument() {
	this.exportTable(this.columnsToExport, this.dataToExport, this.name);
}

function print() {
	window.print();
}

function openAction(item) {
	this.$emit('run-action', item);
}

function setWitdh() {
	this.width = window.innerWidth;
}

function titleBreadCrumb(bc) {
	return bc.title || bc.meta.title;
}

// Máximo de migas visibles según el ancho (evita que la barra se abulte).
function breadMax() {
	return this.width <= 768 ? 2 : 4;
}

// Solo las últimas migas (las más relevantes de la ruta actual).
function breadCrumbsToShow() {
	const all = this.getBreadCrumbs || [];
	return all.length > this.breadMax ? all.slice(all.length - this.breadMax) : all;
}

// ¿Hay migas ocultas antes de las visibles? (para mostrar el "…").
function breadHasMore() {
	return (this.getBreadCrumbs || []).length > this.breadMax;
}

function data() {
	return {
		search: '',
		show: false,
		width: 0,
	};
}

export default {
	name: 'header-page',
	computed: {
		...mapGetters('route', [
			'getBreadCrumbs',
		]),
		columnsToExport,
		dataToExport,
		breadMax,
		breadCrumbsToShow,
		breadHasMore,
	},
	components: {
		actionBar,
	},
	data,
	methods: {
		open,
		downloadDispatch,
		downloadDocument,
		print,
		openAction,
		searchRows,
		setWitdh,
		titleBreadCrumb,
	},
	mounted,
	props: {
		columns: {
			type: Array,
		},
		exportToPdf: {
			default: false,
			type: Boolean,
		},
		name: {
			type: String,
		},
		rows: {
			type: Array,
		},
		showClean: {
			default: true,
			type: Boolean,
		},
		showExcel: {
			default: true,
			type: Boolean,
		},
		title: {
			type: String,
			required: true,
		},
		toShow: {
			default: false,
			type: Boolean,
		},
		quotation: {
			default: false,
			type: Boolean,
		},
		sale: {
			default: false,
			type: Boolean,
		},
		actions: {
			default: false,
			type: Boolean,
		},
		searchHeader: {
			default: false,
			type: Boolean,
		},
		valueDisabled: {
			default: () => [],
			type: Array,
		},
		buttonDelete: {
			default: false,
			type: Boolean,
		},
		buttonFilter: {
			default: false,
			type: Boolean,
		},
		buttonClose: {
			default: false,
			type: Boolean,
		},
		codeJournal: {
			type: String,
		},
		dateJournal: {
			type: String,
		},
		detailJournalOpen: {
			type: Boolean,
			default: false,
		},
	},
};
</script>

<style lang="scss" scoped>
.main-header-page {
	@include flex-between;
	background-color: white ;
	border-bottom: 2px solid map-get($colors, base);
	flex-wrap: nowrap;
	min-height: 42px;
	padding: 0 12px 0 50px;
	width: 100%;

	.header-page-title {
		align-items: center;
		border-radius: 6px;
		color: rgba(44, 64, 74, 0.55);
		cursor: pointer;
		display: inline-flex;
		flex: 0 0 auto;
		font-family: map-get($fonts, AvenirRegular);
		font-size: size(small13);
		margin: 0;
		padding: 3px 6px;
		transition: background-color 0.15s ease, color 0.15s ease;
		white-space: nowrap;

		.header-page-title-text {
			display: inline-block;
			max-width: 170px;
			overflow: hidden;
			text-overflow: ellipsis;
			white-space: nowrap;

			@media (max-width: 768px) {
				max-width: 90px;
			}
		}

		&:hover {
			background: rgba(2, 151, 155, 0.08);
			color: color(secondary);
		}

		@media (max-width: 768px) {
			font-size: size(small10);
			padding: 2px 4px;
		}
	}

	.header-page-title::after {
		color: rgba(44, 64, 74, 0.3);
		content: '›';
		font-size: 15px;
		margin-left: 8px;

		@media (max-width: 768px) {
			margin-left: 4px;
		}
	}

	.header-page-title:last-child {
		color: color(secondary);
		cursor: default;
		font-family: map-get($fonts, AvenirBold);
		pointer-events: none;
	}

	.header-page-title:last-child::after {
		content: '';
		margin-left: 0;
	}

	.header-page-actions {
		@include flex-between;
		flex: 0 0 auto;
		margin-left: 40px;
		.btn {
			@include txt-config (open-semibold, small10);
			background-color: map-get($colors, orange-btn);
			border-radius: 5px;
			color: white;
			height: 25px;
			min-width: 58px;
			text-transform: capitalize;
		}
		.header-page-download-document {
			@include flex-center;
			min-width: 25px;
			margin: 0px;
		}
	}

	@media (max-width: 768px) {
		padding-left: 10px;
	}

	@media (max-width: 954px) {
		position: relative;
	}
}

.translate {
	transform: translateX(-200px);
	display: grid !important;
	grid-template-columns: 20px 20px;
	grid-column-gap: 20px;
}

.bread {
	align-items: center;
	display: flex;
	flex: 1 1 auto;
	flex-wrap: nowrap;
	gap: 1px;
	min-width: 0;
	overflow-x: auto;
	overflow-y: hidden;
	padding: 4px 0;
	-webkit-overflow-scrolling: touch;
	scrollbar-width: thin;

	&::-webkit-scrollbar {
		height: 3px;
	}

	&::-webkit-scrollbar-thumb {
		background: rgba(2, 151, 155, 0.35);
		border-radius: 3px;
	}

	.bread-more {
		color: rgba(44, 64, 74, 0.45);
		flex: 0 0 auto;
		font-size: 15px;
		font-weight: 700;
		letter-spacing: 1px;
		padding: 0 6px 0 2px;
	}

	@media (max-width: 768px) {
		display: none;
	}
}

.action-bar-header {
	display: none;

	@media (max-width: 768px) {
		display: block;
	}
}

.header-page-search {
	display: none;

	@media (max-width: 768px) {
		display: flex;
		justify-content: flex-end;
		width: 100%;
	}
}

.btn-activator {
	bottom: 0;
	margin: auto 0px;
	position: absolute;
	right: 0;
	top: 0;
	width: 24px;
}

.menu-header-page {
	width: 191px;
}

.btn-search {
	background-color: #2c404a !important;
	border-radius: 50% !important;
	min-width: 33px !important;
 	height: 33px !important;
	padding: 0 !important;
}

.search-input {
	align-items: center;
	border: 1px solid #a9bac2 !important;
	background-color: white;
	border-radius: 15px !important;
	color: #a9bac2;
	display: inline-flex;
	font-size: 12px !important;
	font-weight: 500;
	height: 35px;
	margin-right: 11px;
	padding-right: 10px;
	vertical-align: middle;
	width: 100%;
	z-index: 1;

	input {
		color: color(black);
		outline: none;
		padding: 0 10px;
		width: 100%;
	}

	@media (max-width: 768px) {
		&.unique-input {
			width: 50px;
		}
	}
}

.align-center {
	align-items: center;
	display: flex;
	justify-content: flex-end;
	width: 100%;
}

.border-r {
	border-right: 1px solid #e0e5e8;
}

.btn-delete {
	background-color: #ff0000 !important;
	border-radius: 50% !important;
	height: 33px !important;
	padding: 0 !important;
	min-width: 33px !important;

	@media (min-width: 768px) {
		display: none;
	}
}

.content-space-between {
	align-items: center;
	display: flex;
	flex: 0 0 auto;
	justify-content: flex-end;

	@media (min-width: 768px) {
		display: none;
	}

	@media (max-width: 768px) {
		width: 100%;
	}
}

.btn-filter {
	background-color: #5acfc7 !important;
	border-radius: 50% !important;
	height: 33px !important;
	padding: 0 !important;
	min-width: 33px !important;

	@media (min-width: 768px) {
		display: none;
	}
}

.btn-close {
	background-color: white !important;
	border-radius: 50% !important;
	box-shadow: none !important;
	height: 33px !important;
	padding: 0 !important;
	min-width: 33px !important;

	@media (min-width: 768px) {
		display: none;
	}
}

.header-detail-journal-mobile {
	color: #006edb;
	font-weight: 500;
	left: 16px;
	letter-spacing: -0.63px;
	position: absolute;
}
</style>



// WEBPACK FOOTER //
// src/components/shared/header-page.vue